import { createEnv } from "@t3-oss/env-nextjs";
import { z } from "zod";

const env = createEnv({
  server: {
    VERCEL_ENV: z
      .enum(["development", "preview", "production"])
      .default("development"),
    NEXT_PREVIEW_TOKEN: z.string(),
    CENTRA_API_SECRET: z.string(),
    CENTRA_INTEGRATION_TOKEN: z.string(),
    CENTRA_INTEGRATION_URL: z.string().url(),
    CENTRA_COOKIE_SECRET: z.string().optional(),
    STORYBLOK_ACCESS_TOKEN_PREVIEW: z.string(),
    STORYBLOK_ACCESS_TOKEN: z.string(),
  },
  client: {
    NEXT_PUBLIC_BASE_URL: z.string(),
    NEXT_PUBLIC_STORYBLOK_TOKEN: z.string(),
    NEXT_PUBLIC_CENTRA_CHECKOUT_API: z.string(),
    NEXT_PUBLIC_ENV: z.string(),
    NEXT_PUBLIC_GTM_ID: z.string(),
  },
  runtimeEnv: {
    VERCEL_ENV: process.env.VERCEL_ENV,
    NEXT_PUBLIC_BASE_URL: process.env.NEXT_PUBLIC_BASE_URL,
    NEXT_PREVIEW_TOKEN: process.env.NEXT_PREVIEW_TOKEN,
    CENTRA_API_SECRET: process.env.CENTRA_API_SECRET,
    CENTRA_INTEGRATION_TOKEN: process.env.CENTRA_INTEGRATION_TOKEN,
    CENTRA_INTEGRATION_URL: process.env.CENTRA_INTEGRATION_URL,
    CENTRA_COOKIE_SECRET: process.env.CENTRA_COOKIE_SECRET,
    STORYBLOK_ACCESS_TOKEN: process.env.STORYBLOK_ACCESS_TOKEN,
    STORYBLOK_ACCESS_TOKEN_PREVIEW: process.env.STORYBLOK_ACCESS_TOKEN_PREVIEW,
    NEXT_PUBLIC_STORYBLOK_TOKEN: process.env.NEXT_PUBLIC_STORYBLOK_TOKEN,
    NEXT_PUBLIC_CENTRA_CHECKOUT_API:
      process.env.NEXT_PUBLIC_CENTRA_CHECKOUT_API,
    NEXT_PUBLIC_ENV: process.env.NODE_ENV,
    NEXT_PUBLIC_GTM_ID: process.env.NEXT_PUBLIC_GTM_ID,
  },
});

export default env;
